import React from "react";
import Logo from "../../assets/icons/LogoWhite.png";
import GooglePlay from "../../assets/icons/googleplay.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="bg-black p-[20px]">
      <div className="flex flex-col md:flex-row py-0 justify-between md:py-10 px-0 md:px-20">
        <div className="flex flex-col">
          <img src={Logo} alt="" className="w-20 md:w-[200px]" />
          <p className="text-white">Tingkatkan bisnis Farmasimu sekarang</p>
          <a
            href="https://play.google.com/store/apps/details?id=olin.pharmaniaga.app"
            target="_blank"
            rel="noreferrer"
          >
            <img src={GooglePlay} alt="" className="w-20 md:w-[200px]" />
          </a>

          <p className="mt-[140px] hidden md:block text-white text-[9px] md:text-[12px]">
            Ⓒ Copyright 2022 PT Digital Pharma Andalan Indonesia. All Rights
            Reserved.
          </p>
        </div>
        <div className="flex flex-col md:flex-row gap-10">
          <div className="text-white mt-10 md:mt-0">
            <p className="font-bold mb-3">Layanan</p>
            <hr className="text-white visible md:invisible" />
            <p className="mt-3">
              <Link to="/product">Produk</Link>
            </p>

            <p className="my-2">
              <Link to="/perangkat">Perangkat</Link>
            </p>
            {/* <a href="#harga-section" className="my-2">
              <Link to="/product">Harga</Link>
            </a> */}
            <p className="my-2">
              <Link to="/blog">Blog</Link>
            </p>
            <p className="my-2">
              <Link to="/FAQ">FAQ</Link>
            </p>
          </div>
          <div className="text-white mt-5 md:mt-0">
            <p className="font-bold mb-3">Company</p>
            <hr className="text-white visible md:invisible" />
            <p className="mt-3">
              <Link to="/tentang">Tentang</Link>
            </p>
            <p className="my-2">
              <a href="https://api.whatsapp.com/send?phone=6281113307870">
                Hubungi Kami
              </a>
            </p>
            <p className="my-2">
              <Link to="/kebijakan-privasi">Kebijakan Privasi</Link>
            </p>
            <p className="my-2">
              <Link to="/syarat-ketentuan">Syarat & Ketentuan</Link>
            </p>
          </div>
          <div>
            <p className="font-bold mt-5 md:mt-0 text-white">Temukan Kami</p>
            <hr className="text-white mt-3 visible md:invisible" />
            <div className="flex flex-row gap-3 mt-4">
              <a
                href="https://www.facebook.com/profile.php?id=100087468924959"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="29"
                  height="30"
                  viewBox="0 0 29 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 15.081C0 22.2899 5.23571 28.2844 12.0833 29.5V19.0274H8.45833V15H12.0833V11.7774C12.0833 8.15238 14.419 6.13929 17.7226 6.13929C18.769 6.13929 19.8976 6.3 20.944 6.46071V10.1667H19.0917C17.319 10.1667 16.9167 11.0524 16.9167 12.181V15H20.7833L20.1393 19.0274H16.9167V29.5C23.7643 28.2844 29 22.2911 29 15.081C29 7.06125 22.475 0.5 14.5 0.5C6.525 0.5 0 7.06125 0 15.081Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/olin_indonesia/"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.4996 14.9996C19.4996 16.1931 19.0255 17.3377 18.1816 18.1816C17.3377 19.0255 16.1931 19.4996 14.9996 19.4996C13.8061 19.4996 12.6615 19.0255 11.8176 18.1816C10.9737 17.3377 10.4996 16.1931 10.4996 14.9996C10.4996 14.7431 10.5266 14.4926 10.5731 14.2496H8.99961V20.2451C8.99961 20.6621 9.33711 20.9996 9.75411 20.9996H20.2466C20.4465 20.9992 20.638 20.9195 20.7792 20.7781C20.9203 20.6366 20.9996 20.445 20.9996 20.2451V14.2496H19.4261C19.4726 14.4926 19.4996 14.7431 19.4996 14.9996ZM14.9996 17.9996C15.3937 17.9995 15.7839 17.9218 16.1479 17.7709C16.5119 17.62 16.8427 17.3989 17.1212 17.1202C17.3998 16.8415 17.6208 16.5106 17.7715 16.1465C17.9222 15.7824 17.9997 15.3922 17.9996 14.9981C17.9995 14.604 17.9218 14.2139 17.7709 13.8498C17.62 13.4858 17.3989 13.1551 17.1202 12.8765C16.8415 12.5979 16.5106 12.377 16.1465 12.2262C15.7824 12.0755 15.3922 11.998 14.9981 11.9981C14.2023 11.9983 13.4391 12.3146 12.8765 12.8775C12.3139 13.4404 11.9979 14.2038 11.9981 14.9996C11.9983 15.7955 12.3146 16.5586 12.8775 17.1212C13.4404 17.6839 14.2038 17.9998 14.9996 17.9996ZM18.5996 11.8496H20.3981C20.5176 11.8496 20.6322 11.8022 20.7168 11.7179C20.8015 11.6335 20.8492 11.5191 20.8496 11.3996V9.60111C20.8496 9.48136 20.802 9.36652 20.7174 9.28185C20.6327 9.19718 20.5179 9.14961 20.3981 9.14961H18.5996C18.4799 9.14961 18.365 9.19718 18.2803 9.28185C18.1957 9.36652 18.1481 9.48136 18.1481 9.60111V11.3996C18.1496 11.6471 18.3521 11.8496 18.5996 11.8496ZM14.9996 0.599609C11.1805 0.599609 7.5178 2.11675 4.81727 4.81727C2.11675 7.5178 0.599609 11.1805 0.599609 14.9996C0.599609 18.8187 2.11675 22.4814 4.81727 25.1819C7.5178 27.8825 11.1805 29.3996 14.9996 29.3996C16.8906 29.3996 18.7632 29.0271 20.5103 28.3035C22.2573 27.5798 23.8448 26.5191 25.1819 25.1819C26.5191 23.8448 27.5798 22.2573 28.3035 20.5103C29.0271 18.7632 29.3996 16.8906 29.3996 14.9996C29.3996 13.1086 29.0271 11.2361 28.3035 9.48897C27.5798 7.74188 26.5191 6.15444 25.1819 4.81727C23.8448 3.48011 22.2573 2.41941 20.5103 1.69574C18.7632 0.972076 16.8906 0.599609 14.9996 0.599609ZM22.4996 20.8331C22.4996 21.7496 21.7496 22.4996 20.8331 22.4996H9.16611C8.24961 22.4996 7.49961 21.7496 7.49961 20.8331V9.16611C7.49961 8.24961 8.24961 7.49961 9.16611 7.49961H20.8331C21.7496 7.49961 22.4996 8.24961 22.4996 9.16611V20.8331Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/channel/UC_qBcIbgRIYCR0aIPDD7_Bw"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.4041 14.7491L14.0351 13.1771C13.7411 13.0406 13.4996 13.1936 13.4996 13.5191V16.4801C13.4996 16.8056 13.7411 16.9586 14.0351 16.8221L17.4026 15.2501C17.6981 15.1121 17.6981 14.8871 17.4041 14.7491ZM14.9996 0.599609C7.04661 0.599609 0.599609 7.04661 0.599609 14.9996C0.599609 22.9526 7.04661 29.3996 14.9996 29.3996C22.9526 29.3996 29.3996 22.9526 29.3996 14.9996C29.3996 7.04661 22.9526 0.599609 14.9996 0.599609ZM14.9996 20.8496C7.62861 20.8496 7.49961 20.1851 7.49961 14.9996C7.49961 9.81411 7.62861 9.14961 14.9996 9.14961C22.3706 9.14961 22.4996 9.81411 22.4996 14.9996C22.4996 20.1851 22.3706 20.8496 14.9996 20.8496Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/olin-all-in-one-pharmacy-management-system/mycompany/"
                target="_blank"
                rel="noreferrer"
              >
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.9996 0.599609C7.04661 0.599609 0.599609 7.04661 0.599609 14.9996C0.599609 22.9526 7.04661 29.3996 14.9996 29.3996C22.9526 29.3996 29.3996 22.9526 29.3996 14.9996C29.3996 7.04661 22.9526 0.599609 14.9996 0.599609ZM11.4746 20.9681H8.55861V11.5841H11.4746V20.9681ZM9.99861 10.4321C9.07761 10.4321 8.48211 9.77961 8.48211 8.97261C8.48211 8.14911 9.09561 7.51611 10.0361 7.51611C10.9766 7.51611 11.5526 8.14911 11.5706 8.97261C11.5706 9.77961 10.9766 10.4321 9.99861 10.4321ZM22.1246 20.9681H19.2086V15.7676C19.2086 14.5571 18.7856 13.7351 17.7311 13.7351C16.9256 13.7351 16.4471 14.2916 16.2356 14.8271C16.1576 15.0176 16.1381 15.2876 16.1381 15.5561V20.9666H13.2206V14.5766C13.2206 13.4051 13.1831 12.4256 13.1441 11.5826H15.6776L15.8111 12.8861H15.8696C16.2536 12.2741 17.1941 11.3711 18.7676 11.3711C20.6861 11.3711 22.1246 12.6566 22.1246 15.4196V20.9681Z"
                    fill="white"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
